"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPSELL_CLICKED = exports.UPSELL_BANNER_IMAGE_URL = exports.UPSELL_BANNER_FASSPASS_DATA = exports.TOGGLE_FASTPASS = exports.FASTPASS = void 0;
var UPSELL_BANNER_FASSPASS_DATA = {
  text: 'More value! 7 kg Xtra Carry-on, priority boarding and check-in',
  ctaText: 'Upgrade to FastPass'
};
exports.UPSELL_BANNER_FASSPASS_DATA = UPSELL_BANNER_FASSPASS_DATA;
var UPSELL_BANNER_IMAGE_URL = 'https://storage.googleapis.com/static.airasia.com/design/images/flight/upsell-speaker.svg';
exports.UPSELL_BANNER_IMAGE_URL = UPSELL_BANNER_IMAGE_URL;
var UPSELL_CLICKED = 'upsellClicked';
exports.UPSELL_CLICKED = UPSELL_CLICKED;
var FASTPASS = 'fastpass';
exports.FASTPASS = FASTPASS;
var TOGGLE_FASTPASS = 'toggleFastPass';
exports.TOGGLE_FASTPASS = TOGGLE_FASTPASS;